import type { QuestionLongTextSchema } from '@repo/schemas/quiz/questionLongText';

import { standardSchemaResolver } from '@hookform/resolvers/standard-schema';
import { questionLongTextSchema } from '@repo/schemas/quiz/questionLongText';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

export function useQuestionLongForm(data?: QuestionLongTextSchema) {
  const form = useForm<QuestionLongTextSchema>({
    defaultValues: data,
    mode: 'onChange',
    resolver: standardSchemaResolver(questionLongTextSchema),
  });

  //trigger validation on component mount
  useEffect(() => {
    form.trigger();
  }, []);

  const handleRemoveMinLength = () => {
    form.setValue('minLength', undefined);
  };

  const handleRemoveMaxLength = () => {
    form.setValue('maxLength', undefined);
  };

  return {
    form,
    handleRemoveMinLength,
    handleRemoveMaxLength,
  };
}
